import { useState } from 'react'
import cx from 'classnames'
import styles from './Faq.module.scss'
import { openWhatsApp } from '../constants'

const QUESTIONS = [
  {
    q: 'O atendimento online funciona para crianças?',
    a: 'Sim! As sessões são dinâmicas e lúdicas, pensadas para manter a criança engajada. Muitas famílias relatam ótima evolução com o atendimento online.',
  },
  {
    q: 'Atende adultos também?',
    a: 'Sim. Atendemos adultos que buscam aprimorar a comunicação, a voz, a fluência e a articulação, tanto no contexto pessoal quanto profissional.',
  },
  {
    q: 'A partir de qual idade a criança pode fazer terapia online?',
    a: 'O atendimento é avaliado caso a caso. Há também consultoria para responsáveis de crianças pequenas, com orientações para estimular a comunicação inicial.',
  },
  {
    q: 'Preciso de quê para fazer a sessão?',
    a: 'Apenas um computador, tablet ou celular com câmera e uma conexão de internet estável, em um ambiente tranquilo.',
  },
  {
    q: 'Quanto tempo dura a sessão?',
    a: 'As sessões têm duração de 30 minutos, conforme o plano terapêutico definido para cada paciente.',
  },
  {
    q: 'Como saber se eu ou meu filho precisamos de fono?',
    a: 'Na dúvida, agende uma avaliação. Conversamos sobre as suas queixas e identificamos juntos o melhor caminho para a sua evolução.',
  },
]

const Faq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  const toggle = (index: number) =>
    setOpenIndex(current => (current === index ? null : index))

  return (
    <section id="duvidas" className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.list}>
          <h2>Perguntas frequentes</h2>
          {QUESTIONS.map((item, index) => {
            const isOpen = openIndex === index
            return (
              <div key={item.q} className={cx(styles.item, { [styles.open]: isOpen })}>
                <button type="button" className={styles.question} onClick={() => toggle(index)}>
                  <span>{item.q}</span>
                  <i className="material-icons">{isOpen ? 'remove' : 'add'}</i>
                </button>
                {isOpen && <p className={styles.answer}>{item.a}</p>}
              </div>
            )
          })}
        </div>

        <aside className={styles.help}>
          <span className={styles.helpIcon}>
            <i className="material-icons">help_outline</i>
          </span>
          <h3>Ainda tem dúvidas?</h3>
          <p>Fale conosco pelo WhatsApp. Será um prazer ajudar!</p>
          <button type="button" className={styles.helpBtn} onClick={openWhatsApp}>
            Falar no WhatsApp <i className="material-icons">chat</i>
          </button>
        </aside>
      </div>
    </section>
  )
}

export default Faq
